import { IApplicationState } from '../../types/redux';

export const selectIsModalOpen = (state: IApplicationState) => {
  return state.listingModal.open;
};
